var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.274,
    height: 16,
    viewBox: "0 0 17.274 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_date_2149188",
    transform: "translate(396 -146.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(-396 146.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M27.257,31.274H26.124V30.6a.6.6,0,0,0-1.2,0v.673H16.6V30.6a.6.6,0,0,0-1.2,0v.673H14.018A2.012,2.012,0,0,0,12,33.281v10.7A2.019,2.019,0,0,0,14.018,46H27.257a2.021,2.021,0,0,0,2.018-2.018v-10.7A2.01,2.01,0,0,0,27.257,31.274Zm.814,12.708a.814.814,0,0,1-.814.814H14.018a.814.814,0,0,1-.814-.814V36.336H28.071ZM13.2,35.133V33.281a.805.805,0,0,1,.814-.8H15.4v.45a.6.6,0,0,0,1.2,0v-.45H24.92v.45a.6.6,0,1,0,1.2,0v-.45h1.133a.805.805,0,0,1,.814.8v1.851Z",
    transform: "translate(-12 -30)",
    fill: "#97a3b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonu);
export default __webpack_public_path__ + "static/media/nonu.d7a0bd199424b06a353e7c6a7f7c404f.svg";
export { ForwardRef as ReactComponent };